export const INTEGRATIONS_SCHEMA = {
  shopify: {
    title: "Shopify",
    description: "E-commerce platform for online store",
    icon: "ShoppingBag",
    color: "from-green-500 to-green-600",
    fields: [
      {
        name: "shopDomain",
        label: "Shop Domain",
        type: "text",
        required: true,
        placeholder: "yourstore.myshopify.com",
        help: "Your Shopify store URL (without https://)"
      },
      {
        name: "token",
        label: "Admin API Access Token",
        type: "secret",
        required: true,
        placeholder: "shpat_xxxxxxxxxxxxx",
        help: "Settings → Apps → Develop apps → Create app → Admin API access token"
      },
      {
        name: "apiVersion",
        label: "API Version",
        type: "text",
        required: false,
        default: "2024-01",
        placeholder: "2024-01"
      }
    ],
    serverSecrets: [{ name: "SHOPIFY_TOKEN", label: "Shopify Admin API token" }]
  },

  claude: {
    title: "Claude AI",
    description: "AI for product descriptions & photo analysis",
    icon: "Sparkles",
    color: "from-purple-500 to-primary",
    fields: [
      {
        name: "apiKey",
        label: "API Key",
        type: "secret",
        required: true,
        placeholder: "sk-ant-xxxxxxxxxxxxx",
        help: "Get your API key from console.anthropic.com"
      },
      {
        name: "model",
        label: "Default Model",
        type: "select",
        required: false,
        default: "claude-sonnet-4-6",
        options: [
          { value: "claude-sonnet-4-6", label: "Claude Sonnet 4.6 (Recommended)" },
          { value: "claude-opus-4-8", label: "Claude Opus 4.8 (Most Capable)" },
          { value: "claude-haiku-4-5", label: "Claude Haiku 4.5 (Fastest)" }
        ]
      }
    ],
    serverSecrets: [{ name: "CLAUDE_API_KEY", label: "Claude API Key" }]
  },

  kie_ai: {
    title: "KIE AI",
    description: "Nano Banana Pro image generation",
    icon: "ImagePlus",
    color: "from-orange-500 to-amber-600",
    fields: [
      {
        name: "apiKey",
        label: "API Key",
        type: "secret",
        required: true,
        placeholder: "kie_xxxxxxxxxxxxx",
        help: "Get your API key from kie.ai dashboard"
      },
      {
        name: "baseUrl",
        label: "Base URL",
        type: "text",
        required: false,
        default: "https://api.kie.ai",
        placeholder: "https://api.kie.ai"
      },
      {
        name: "model",
        label: "Model",
        type: "text",
        required: false,
        default: "nano-banana-pro",
        placeholder: "nano-banana-pro"
      },
      {
        name: "closeAspectRatio",
        label: "Close Shot Aspect",
        type: "text",
        required: false,
        default: "1:1",
        placeholder: "1:1"
      },
      {
        name: "modelAspectRatio",
        label: "Model Shot Aspect",
        type: "text",
        required: false,
        default: "3:4",
        placeholder: "3:4"
      },
      {
        name: "outputFormat",
        label: "Output Format",
        type: "select",
        required: false,
        default: "png",
        options: [
          { value: "png", label: "PNG" },
          { value: "jpg", label: "JPG" }
        ]
      }
    ],
    serverSecrets: [{ name: "KIE_API_KEY", label: "KIE API Key" }]
  },

  google_drive: {
    title: "Google Drive",
    description: "File storage, upload photos, create/edit files",
    icon: "HardDrive",
    color: "from-blue-500 to-blue-600",
    fields: [
      {
        name: "clientEmail",
        label: "Service Account Email",
        type: "text",
        required: true,
        placeholder: "service-account@project.iam.gserviceaccount.com",
        help: "Email from the Service Account JSON file (client_email)"
      },
      {
        name: "privateKey",
        label: "Private Key",
        type: "secret",
        required: true,
        placeholder: "-----BEGIN PRIVATE KEY-----...",
        help: "Copy the private_key value from the JSON file"
      },
      {
        name: "folderId",
        label: "Root Folder ID",
        type: "text",
        required: true,
        placeholder: "1hA3xYz...",
        help: "ID from folder URL - share this folder with the Service Account email"
      }
    ],
    serverSecrets: [{ name: "GOOGLE_DRIVE_PRIVATE_KEY", label: "Google Drive Private Key" }]
  },

  google_sheets: {
    title: "Google Sheets",
    description: "Spreadsheet data and reports",
    icon: "Table",
    color: "from-emerald-500 to-emerald-600",
    fields: [
      {
        name: "clientEmail",
        label: "Service Account Email",
        type: "text",
        required: true,
        placeholder: "service-account@project.iam.gserviceaccount.com",
        help: "Email from Service Account JSON - share spreadsheet with this email"
      },
      {
        name: "privateKey",
        label: "Private Key",
        type: "secret",
        required: true,
        placeholder: "-----BEGIN PRIVATE KEY-----...",
        help: "Copy the private_key from the JSON file"
      },
      {
        name: "spreadsheetId",
        label: "Spreadsheet ID",
        type: "text",
        required: false,
        placeholder: "1x2y3z...abc",
        help: "Copy from spreadsheet URL between /d/ and /edit"
      }
    ],
    serverSecrets: [{ name: "GOOGLE_SHEETS_PRIVATE_KEY", label: "Google Sheets Private Key" }]
  },

  google_calendar: {
    title: "Google Calendar",
    description: "Calendar events and scheduling",
    icon: "Calendar",
    color: "from-red-500 to-red-600",
    fields: [
      {
        name: "clientEmail",
        label: "Service Account Email",
        type: "text",
        required: true,
        placeholder: "service-account@project.iam.gserviceaccount.com",
        help: "Email from Service Account JSON - share calendar with this email"
      },
      {
        name: "privateKey",
        label: "Private Key",
        type: "secret",
        required: true,
        placeholder: "-----BEGIN PRIVATE KEY-----...",
        help: "Copy the private_key from the JSON file"
      },
      {
        name: "calendarId",
        label: "Calendar ID",
        type: "text",
        required: false,
        default: "primary",
        placeholder: "primary or team@yourdomain.com",
        help: "Use 'primary' for main calendar or email for shared calendar"
      }
    ],
    serverSecrets: [{ name: "GOOGLE_CALENDAR_PRIVATE_KEY", label: "Google Calendar Private Key" }]
  },

  podium: {
    title: "Podium",
    description: "Customer messaging and reviews",
    icon: "MessageSquare",
    color: "from-purple-500 to-purple-600",
    fields: [
      {
        name: "apiKey",
        label: "API Key / Access Token",
        type: "secret",
        required: true,
        placeholder: "pdm_xxx... or Bearer token",
        help: "Podium Dashboard → Settings → Integrations → API"
      },
      {
        name: "locationUid",
        label: "Location UID",
        type: "text",
        required: false,
        placeholder: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
        help: "Your business location ID (for sending messages)"
      },
      {
        name: "baseUrl",
        label: "Base URL",
        type: "text",
        required: false,
        default: "https://api.podium.com"
      }
    ],
    serverSecrets: [{ name: "PODIUM_API_KEY", label: "Podium API key" }]
  },

  metal_prices: {
    title: "Metal Prices",
    description: "Real-time gold and silver prices for Gold Buyer",
    icon: "Coins",
    color: "from-yellow-500 to-warning",
    fields: [
      {
        name: "primaryApi",
        label: "Primary API",
        type: "select",
        required: true,
        default: "metals_live",
        options: [
          { value: "metals_live", label: "Metals.live (Free, no key)" },
          { value: "goldapi", label: "GoldAPI.io (Free tier: 300/month)" },
          { value: "metalpriceapi", label: "MetalPriceAPI.com (Free tier)" }
        ],
        help: "Primary API for fetching metal prices"
      },
      {
        name: "goldapiKey",
        label: "GoldAPI.io API Key",
        type: "secret",
        required: false,
        placeholder: "goldapi-xxxxxxxxxxxxx",
        help: "Get free API key at goldapi.io (optional fallback)"
      },
      {
        name: "metalpriceapiKey",
        label: "MetalPriceAPI.com API Key",
        type: "secret",
        required: false,
        placeholder: "xxxxxxxxxxxxxxxxxxxxxxxx",
        help: "Get free API key at metalpriceapi.com (optional fallback)"
      },
      {
        name: "refreshInterval",
        label: "Refresh Interval (minutes)",
        type: "select",
        required: false,
        default: "10",
        options: [
          { value: "5", label: "Every 5 minutes" },
          { value: "10", label: "Every 10 minutes (Recommended)" },
          { value: "15", label: "Every 15 minutes" },
          { value: "30", label: "Every 30 minutes" },
          { value: "60", label: "Every hour" }
        ]
      },
      {
        name: "desagioPercent",
        label: "Default Desagio (%)",
        type: "text",
        required: false,
        default: "5",
        placeholder: "5",
        help: "Default percentage below spot price for buying gold"
      }
    ],
    serverSecrets: [
      { name: "GOLDAPI_KEY", label: "GoldAPI.io API Key" },
      { name: "METALPRICEAPI_KEY", label: "MetalPriceAPI.com API Key" }
    ]
  }
};
